// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userListUsersTableStyles } from "@insite/content-library/Widgets/UserList/UserListUsersTable";
import dataTableStyles from "@sc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

userListUsersTableStyles.usernameCells = {
    css: css`
        font-weight: 400;
        ${xScreen("lt", "sm")} {
            max-width: 210px;
            span {
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 200px;
            }
        }
    `,
};

userListUsersTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

userListUsersTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};
